import React, { useState } from 'react';
import { TrashCanOutlined } from '@duxton-web/icons';
import { Button, Modal, ModalProps, Tooltip } from '@duxton-web/ui';

import { useExperimentDispatchContext } from '../../contexts/experiment-context';
import { deleteTreatment } from '../../store/actions/experiment/action-creators';

const DeleteTreatmentModal = ({ open, onCancel, onOk }: ModalProps) => {
  if (!open) return null;

  return (
    <Modal
      centered
      width={600}
      title="Delete Treatment"
      open={open}
      onCancel={onCancel}
      onOk={onOk}
      okText="Delete Treatment"
      maskClosable={false}
      okButtonProps={{
        size: 'small',
        danger: true,
      }}
      cancelButtonProps={{
        size: 'small',
      }}
    >
      <p>Are you sure you want to delete this treatment?</p>
    </Modal>
  );
};

const DeleteTreatment = ({ index }: { index: number }) => {
  const experimentDispatch = useExperimentDispatchContext();

  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title="Click here to delete treatment">
        <Button
          icon={<TrashCanOutlined />}
          size="small"
          shape="circle"
          type="text"
          onClick={() => setOpen(true)}
        />
      </Tooltip>
      <DeleteTreatmentModal
        open={open}
        onCancel={() => setOpen(false)}
        onOk={() => {
          setOpen(false);

          experimentDispatch(deleteTreatment(index));
        }}
      />
    </>
  );
};

export default DeleteTreatment;
